// This includes everything in the './base' directory and registers it as global
// Vue components. Use this for basic UI elements and such.
import Vue from 'vue/dist/vue.esm.js';

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context('./base', false, /\.(vue|js)$/);

requireComponent.keys().forEach(fileName => {
  const componentName = upperFirst(camelCase(fileName.split('/').pop().replace(/\.\w+$/, '')))
  const componentConfig = requireComponent(fileName);

  Vue.component(componentName, componentConfig.default || componentConfig);
});
